export default __webpack_public_path__ + "static/media/notas_fiscais_gif_light_mode.c145ce8e.gif";